<template>
	<div>
		<action-sidebar
			title="Activar Plan de Cuentas"
			:value="true"
			@close-modal="closeModal"
		>
			<acc-plan-active-form
				:subsidiary-id="params.subsidiaryId"
				:year-accountant-id="params.yearAccountantId"
			/>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import accPlanActiveForm from '@/components/accounting-plans/acc-plan-active-form';

function created() {
	if (this.subsidiaryId) {
		this.params.subsidiaryId = this.subsidiaryId;
	}
	if (this.yearAccountantId) {
		this.params.yearAccountantId = this.yearAccountantId;
	}
}

function closeModal() {
	this.goTo('accounting-plans', { params: { subsidiaryId: this.params.subsidiaryId } });
}

export default {
	name: 'page-accounting-plan-active',
	components: {
		actionSidebar,
		accPlanActiveForm,
	},
	created,
	methods: {
		closeModal,
	},
	props: {
		subsidiaryId: [Number, String],
		yearAccountantId: [Number, String],
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/accounting-plans/page-accounting-plan-active.vue